const items = {
  seasons: ['Peak 1', 'Peak 2', 'Peak 3', 'Peak 4', 'Red', 'White', 'Blue', 'Flexi'],
  resortBedrooms: ['Studio', '1', '2', '3', '4', '5', '6'],
  maxBedrooms: ['2', '4', '5', '6', '8', '10', '12'],
  bankedEntities: ['Dial an Exchange', 'RCI', 'First Exchange', 'iExchange',
    'Interval International',
  ],
};
export default items;
